/**
 * GET quickbooks/companies, normalised: always resolves (never rejects) to a list.
 * A non-200, an unparseable body, a non-array body (e.g. graphql's {status, message, correlationId} error
 * object) or a network failure all resolve to [] - so callers can always stop their loading state.
 */
export const loadQuickbooksCompanies = (
	fetchRaw: (path: string) => Promise<{status: number; json: () => Promise<unknown>}>
): Promise<unknown[]> =>
	fetchRaw('quickbooks/companies')
		.then(result => (result.status === 200 ? result.json() : null))
		.then(body => (Array.isArray(body) ? body : []))
		.catch(() => []);
